import { IHardwareNotificationSubscriptionResponse } from '@kcftech/prometheustypescriptapiclient';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';

export type HardwareNotificationSubscriptionsFilter = Readonly<{
    corporationId?: string;
    locationId?: string;
    userId?: string;
    nameSearch?: string;
}>;

export const buildFilterExpression = ({
    corporationId,
    locationId,
    userId,
}: Partial<HardwareNotificationSubscriptionsFilter>) =>
    Filter.and(
        corporationId && Filter.eq('CorporationId', corporationId),
        locationId && Filter.eq('LocationId', locationId),
        userId && Filter.eq('UserId', userId)
    );

export type UseHardwareNotificationSubscriptionsDataSourceOptions = BaseDataSourceOptions<
    IHardwareNotificationSubscriptionResponse,
    HardwareNotificationSubscriptionsFilter
>;

export type HardwareNotificationSubscriptionsPagedDataSource = PagedDataSource<
    IHardwareNotificationSubscriptionResponse,
    HardwareNotificationSubscriptionsFilter
>;

export type HardwareNotificationSubscriptionsInfiniteDataSource = InfiniteDataSource<
    IHardwareNotificationSubscriptionResponse,
    HardwareNotificationSubscriptionsFilter
>;

export const getAllHardwareNotificationSubscriptions: DataSourceQuery<
    IHardwareNotificationSubscriptionResponse,
    HardwareNotificationSubscriptionsFilter
> = ({ filter: { nameSearch, ...filterRest }, sort, page, pageLimit }) => {
    const filter = buildFilterExpression(filterRest);
    const orderBy = buildOrderBy(sort);
    return toDataSourceResult(
        sdClient.getHardwareNotificationSubscriptions({
            filter,
            page,
            pageLimit,
            orderBy,
            nameSearch,
        })
    );
};

export function usePagedHardwareNotificationSubscriptionsDataSource({
    ...options
}: UseHardwareNotificationSubscriptionsDataSourceOptions): HardwareNotificationSubscriptionsPagedDataSource {
    return usePagedDataSource({
        ...options,
        query: getAllHardwareNotificationSubscriptions,
    });
}

export function useInfiniteHardwareNotificationSubscriptionsDataSource({
    ...options
}: UseHardwareNotificationSubscriptionsDataSourceOptions): HardwareNotificationSubscriptionsInfiniteDataSource {
    return useInfiniteDataSource({
        ...options,
        query: getAllHardwareNotificationSubscriptions,
    });
}
